import { Sentinel } from "../model_gen/sentinel";
import GeneralService from "./GeneralService";
import { Component } from "react";

export class SentinelService extends Component {
  public static getSimpleSentinels(
    offset: number,
    limit: number,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.get(
      `/sentinel/simple/${offset}/${limit}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getAllSentinels(
    offset: number,
    limit: number,
    companyIds: number[],
    loadingHandler: any,
    apiKey: string
  ) {
    const companyIdParam =
      companyIds?.length > 0 ? `company_ids=${companyIds.join(",")}` : "";
    const baseUrl = `/sentinel/offset/${offset}/limit/${limit}`;
    const url = companyIdParam ? `${baseUrl}?${companyIdParam}` : baseUrl;

    return GeneralService.get(
      url,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getSentinel(
    sentinelId: number,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.get(
      `/sentinel/${sentinelId}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getSentinelsByIntentName(
    intentName: string,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.get(
      `/sentinel/intent-group/name/${encodeURIComponent(intentName)}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static updateSentinel(
    sentinel: Sentinel | undefined,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.put(
      "/sentinel/",
      JSON.stringify(sentinel),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static generateSentinel(
    payload: any,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.post(
      "/sentinel/generate/new",
      JSON.stringify(payload),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static regenerateSentinel(
    sentinelId: number,
    payload: any,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.post(
      `/sentinel/${sentinelId}/regenerate`,
      JSON.stringify(payload),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static regenerateSentinelQualification(
    sentinelId: number,
    payload: any,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.post(
      `/sentinel/${sentinelId}/regenerate/qualification`,
      JSON.stringify(payload),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static regenerateSentinelEvaluation(
    sentinelId: number,
    payload: any,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.post(
      `/sentinel/${sentinelId}/regenerate/evaluation`,
      JSON.stringify(payload),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static regenerateSentinelCorrection(
    sentinelId: number,
    payload: any,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.post(
      `/sentinel/${sentinelId}/regenerate/correction`,
      JSON.stringify(payload),
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static deleteSentinel(
    sentinelId: number,
    loadingHandler: any,
    apiKey: string
  ) {
    return GeneralService.delete(
      `/sentinel/${sentinelId}`,
      "",
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }

  public static getSentinelsByIntentGroup(
    intentGroupId: number,
    loadingHandler: any,
    apiKey: string,
    page: number = 1,
    pageSize: number = 10
  ) {
    const offset = (page - 1) * pageSize;
    return GeneralService.get(
      `/sentinel/intent-group/${intentGroupId}/${offset}/${pageSize}`,
      loadingHandler,
      JSON,
      GeneralService.PROD_ENDPOINT,
      apiKey
    );
  }
}
